import { gql } from '@apollo/client'

const ALLERGENS_QUERY = gql`
  query allergens {
    allergens {
      results {
        id
        name

        includedAllergens {
          id
        }

        includedIngredients {
          id
        }
      }
    }
  }
`

export default ALLERGENS_QUERY
